import { Box, Icon, Image, SxProps } from "@outschool/backpack";
import { IconDefinition } from "@outschool/icons";
import React from "react";

import yellowBlobAccent from "../../../../images/yellowBlobAccent.svg";

export default function IconWithBackground({
  icon,
  iconSx,
  backgroundImage,
}: {
  icon: IconDefinition;
  iconSx?: SxProps;
  backgroundImage: string;
}) {
  return (
    <Box sx={{ position: "relative", width: 28, height: 24 }}>
      <Icon
        icon={icon}
        size={"small"}
        sx={{
          zIndex: 1,
          position: "absolute",
          bottom: 0,
          left: 1,
          ...iconSx,
        }}
      />
      <Image
        src={backgroundImage}
        alt=""
        sx={{
          width: 28,
          height: 24,
          position: "relative",
          top: 0,
          left: "4px !important",
        }}
      />
    </Box>
  );
}

export function YellowBlobIcon({
  icon,
  iconSx,
}: {
  icon: IconDefinition;
  iconSx?: SxProps;
}) {
  return (
    <IconWithBackground
      icon={icon}
      iconSx={iconSx}
      backgroundImage={yellowBlobAccent}
    />
  );
}
